// HindiKrutidevTyping.jsx
import React, { useRef } from 'react';
import './HindiKrutidevTyping.css';

const HindiKrutidevTyping = ({
    input,
    setInput,
    started,
    setStarted,
    selectedParagraph,
    calculateMetrics,
    handleTestComplete,
    setKeyCount,
    textareaRef,
    paragraphRef
  }) => {
  const handleChange = (e) => {
    // Krutidev uses onKeyDown for engine logic, not onChange
    // This is just to satisfy the textarea's onChange prop
  };
  const handleKeyDown = (e) => {
    e.preventDefault();
    // Start test
    if (!started) {
      document.documentElement.requestFullscreen().catch(() => {});
      setStarted(true);
    }
    // BACKSPACE
    if (e.key === "Backspace") {
      setInput(prev => {
        const updated = prev.slice(0, -1);
        calculateMetrics(updated);
        return updated;
      });
      setKeyCount(prev => prev + 1);
      return;
    }
    // NORMAL TYPING (same as your demo)
    if (e.key.length === 1) {
      const newValue = input + e.key;
      if (newValue.length > selectedParagraph.length) return;
      setInput(newValue);
      calculateMetrics(newValue);
      setKeyCount(prev => prev + 1);
      // Auto scroll
      if (paragraphRef.current) {
        const progress = newValue.length / selectedParagraph.length;
        const maxScroll =
          paragraphRef.current.scrollHeight -
          paragraphRef.current.clientHeight;
        paragraphRef.current.scrollTop = maxScroll * progress;
      }
      // Auto complete
      if (newValue.length === selectedParagraph.length) {
        handleTestComplete();
      }
    }
  };

  return (
    <textarea
      ref={textareaRef}
      value={input}
      onChange={handleChange} // Empty handler to satisfy React
      onKeyDown={handleKeyDown}
      disabled={false}
      placeholder={started ? "Continue typing..." : "Start typing here to begin test..."}
      className="typing-input"
      spellCheck={false}
      onPaste={(e) => e.preventDefault()}
      onCopy={(e) => e.preventDefault()}
      onCut={(e) => e.preventDefault()}
      onContextMenu={(e) => e.preventDefault()}
      autoComplete="off"
      autoCorrect="off"
      autoCapitalize="off"
    />
  );
};

export default HindiKrutidevTyping;